import { DataModelsData, DataModelsState, RootState } from '../types'

export const SET_DATA_MODELS = 'dataModel//SET_DATA_MODELS'

interface SetDataModelsAction {
  type: typeof SET_DATA_MODELS
  payload: DataModelsData
}

type DataModelsActions = SetDataModelsAction

export function setDataModels(data: DataModelsData): SetDataModelsAction {
  return {
    type: SET_DATA_MODELS,
    payload: data,
  }
}

export function getDataModels(store: RootState): DataModelsState['data'] {
  return store.dataModel.data
}

const initialState: DataModelsState = {
  data: {} as DataModelsData,
}

// eslint-disable-next-line func-names
export default function dataModelsReducer(
  state: DataModelsState | undefined,
  action: DataModelsActions
): DataModelsState {
  const currentState = state || initialState
  switch (action.type) {
    case SET_DATA_MODELS:
      return {
        ...currentState,
        data: action.payload,
      }

    default:
      return currentState
  }
}
